import { Component, OnDestroy, signal } from '@angular/core';
import { RopoApiService } from '../../../../service/api/ropo-api.service';
import { BaseView } from '../../../base-view';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { environment } from '../../../../../environments/environment';
import { Utils } from '../../../../common/utils';
import { firstValueFrom } from 'rxjs';
import { RequestHandler } from 'src/app/service/OffService/request-handler';

import { InformeInterface, InformeREGEPA, InformeROMA, InformeROPO } from './informe.interface';

import jsPDF from 'jspdf';
import { autoTable, Color } from 'jspdf-autotable';
import { HttpClient, HttpParams } from '@angular/common/http';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

export enum tipoCarnet {
    BÁSICO = 'BÁSICO',
    CUALIFICADO = 'CUALIFICADO',
    FUMIGADOR = 'FUMIGADOR',
    PILOTO = 'PILOTO',
    ASESOR = 'ASESOR'
}

@Component({
    selector: 'app-consultas',
    standalone: false,
    templateUrl: './consultas.component.html',
    styleUrls: ['./consultas.component.scss']
})

export class ConsultasComponent extends BaseView<InformeInterface> implements OnDestroy {

    readonly isLoading = signal<boolean>(false);

    public localizado = false;

    public dni = '';

    public showRopo = false;

    public showRoma = false;

    public showRegepa = false;

    public appName = environment.appName;

    public informe: InformeInterface[] = [];

    public informeREGEPA = {} as InformeREGEPA;

    public informeROMA: InformeROMA[] = [];

    public informeROPO: InformeROPO[] = [];

    public showInforme = false;

    public logoUrl = environment.logoUrl;

    public hoy = Utils.formatDate(new Date());

    public listadoDnis: string[] = [];

    public imprimirRopo = false;

    public imprimirRopoMultiple = false;

    public contadorDnis = 0;

    public maxDnis = 0;

    public charset = 'windows-1252';

    codigo_regepa = '';

    public isGeneratingCanvas = false;

    constructor(
        private readonly http: HttpClient,
        private readonly _ropoService: RopoApiService,
        public dashboard: DashboardService,
        private readonly messageService: MessageService,
        private readonly router: Router
    ) {
        super(dashboard, new RequestHandler());
    }

    buscaDni(): void {

        this.isLoading.set(true);
        this.localizado = false;
        this.showRopo = false;
        this.showRoma = false;
        this.showRegepa = false;
        this.codigo_regepa = '';

        const data = firstValueFrom(this._ropoService.getDatosDni(this.dni));
        
        console.log(data);
        

        (firstValueFrom(this._ropoService.getDatosDni(this.dni)))
             .then((resp) => {
                 console.log('resp[2].data', resp);



                 try {
                     this.codigo_regepa = (resp[1]?.data as InformeREGEPA).código ?? '';
                 } catch (error) {
                     console.log(error);
                     this.codigo_regepa = '';
                 }

                 this.informe = resp;
                 if (this.informe != null) {

                     if (this.informe[0]?.errores.length === 0) {
                         this.showRopo = true;
                         this.informeROPO = this.informe[0]?.data as InformeROPO[];
                     };
                     if (this.informe.length >= 2) {
                         if (this.informe[1]?.errores.length === 0) {
                         this.showRoma = true;
                         const todasLasMaquinas = this.informe[1]?.data as InformeROMA[];
                         this.informeROMA = todasLasMaquinas.filter(m => 
                             m.estado?.toLowerCase() === 'alta'
                         );
                     };
                     }

                     if (this.informe.length >= 3) {
                         if (this.informe[1]?.errores.length === 0) {
                             this.showRegepa = true;
                             this.informeREGEPA = this.informe[2]?.data as InformeREGEPA;
                         };
                     }

                 }

                 if (this.informe.length >= 2 && this.informe[1]?.data) {
                     for (const informeRoma of this.informe[1].data as InformeROMA[]) {
                         informeRoma.tipo = Utils.htmlEntities(informeRoma.tipo);
                     }
                 }


                 this.localizado = true;
                 this.showInforme = true;
                 this.isLoading.set(false);

                 return;
             })
             .catch((error: string) => { 
                    console.log('error', error);
                    this.isLoading.set(false);
                    this.localizado = true;
                 })
             .finally(() => {
                this.isLoading.set(false);
             });
    }

    saveWorker(): void {
        if (this.informeROPO.length === 0) {
            return;
        }
        const carnets = this.extraerCarnetsDeROPO();
        const payload = {
            carnets: carnets,
            informeRoma: this.informeROMA,
            activo: 1,
            id_cliente: StorageManager.getClient()?.id,
            id_usuario: StorageManager.getUser().id
        };

        console.log('PAYLOAD enviado al backend:', JSON.stringify(payload, null, 4));

        const params = new HttpParams()
            .set('p1', 'crm')
            .set('p2', 'save');

        this.http.post(
            environment.serverUrl + 'ws/index.php',
            JSON.stringify(payload),
            { params }
        ).subscribe((res: any) => {

            if (res.statusCode === 200) {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Registro guardado',
                    detail: 'El registro se ha guardado correctamente.'
                });
            }

            if (res.statusCode === 400) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error al guardar el registro',
                    detail: 'El registro no se ha guardado correctamente.' + '\n' + res.data.error
                });
            }

            if (res.statusCode === 404) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error al guardar el registro',
                    detail: 'El registro no se ha guardado correctamente.' + '\n' + res.data.error
                });
            }

            if (res.statusCode === 102) {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'El registro ya existe',
                    detail: 'El registro ya existe para este cliente'
                });
            }

        });
    }


    public imprimirConsulta(): void {
        // Verificar que haya datos para generar el PDF
        if ((!this.showRopo || this.informeROPO.length === 0) && (!this.showRoma || this.informeROMA.length === 0)) {
            console.error('No hay datos para generar el PDF.');
            return;
        }

        this.isGeneratingCanvas = true;

        try {
            const doc = new jsPDF('portrait', 'mm', 'a4'); // Configuración del PDF

            // **Agregar Título General**
            doc.setFontSize(18);
            doc.text('Informe Completo', 14, 22);

            let finalY = 30; // Posición inicial después del título

            // **Agregar Primera Tabla: Informe ROPO**
            if (this.showRopo && this.informeROPO.length > 0) {
                // **Agregar Título de la Tabla**

                doc.setFontSize(14);
                doc.text('Tabla de Empleados (ROPO)', 14, finalY);
                finalY += 5; // Espacio entre título y tabla

                // **Preparar Encabezados y Datos**
                const headersROPO: string[] = ['Código', 'Nombre', 'Nivel', 'Fecha Caducidad' , 'Categoría'];
                const dataROPO: any[][] = this.informeROPO.map(ropo => [
                    ropo['código'] || '',
                    ropo.nombre || '',
                    ropo.nivel || '',
                    ropo.caducidad || '',
                    ropo['categoría'] || ''
                ]);

                // **Agregar la Tabla ROPO**
                finalY = this.agregarTabla(
                    doc,
                    headersROPO,
                    dataROPO,
                    finalY,
                    [22, 160, 133],    // Color de fondo del encabezado (RGB)
                    255,                // Color de texto del encabezado (RGB)
                    'striped'           // Tema de la tabla
                );
            }

            // **Agregar Segunda Tabla: Informe ROMA**
            if (this.showRoma && this.informeROMA.length > 0) {
                doc.setFontSize(14);
                doc.text('Tabla de Equipos (ROMA)', 14, finalY);
                finalY += 5; // Espacio entre título y tabla

                const headersROMA: string[] = ['Código', 'Tipo', 'Marca', 'Modelo', 'Estado', 'Fecha Inspección'];
                const dataROMA: any[][] = this.informeROMA.map(roma => [
                    roma.codigo || '',
                    roma.tipo || '',
                    roma.marca || '',
                    roma.modelo || '',
                    roma.estado || '',
                    roma.fecha_inspeccion || '',
                    roma.fecha_caducidad || ''
                ]);

                // **Agregar la Tabla ROMA**
                finalY = this.agregarTabla(
                    doc,
                    headersROMA,
                    dataROMA,
                    finalY,
                    [52, 152, 219],     
                    255,                
                    'striped'
                );
            }

            // **Agregar Pie de Página (Número de Página)**
            const pageCount = doc.getNumberOfPages();

            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.setFontSize(10);
                const pageHeight = doc.internal.pageSize.getHeight();

                doc.text(`Página ${i} de ${pageCount}`, doc.internal.pageSize.getWidth() - 30, pageHeight - 10, { align: 'right' });
            }

            // **Guardar el PDF**
            doc.save(`Consulta_Completa_${this.dni}.pdf`);
        } catch (error) {
            console.error('Error generando el PDF:', error);
        } finally {
            this.isGeneratingCanvas = false;
        }
    }

    /**
     * Función auxiliar para agregar una tabla al PDF
     * @param doc Instancia de jsPDF
     * @param headers Arreglo de encabezados de la tabla
     * @param data Arreglo de arreglos con los datos de la tabla
     * @param startY Posición Y donde comenzará la tabla
     * @param headFillColor Color de fondo del encabezado (RGB)
     * @param headTextColor Color de texto del encabezado (RGB)
     * @param theme Tema de la tabla ('striped', 'grid', 'plain')
     * @returns Nueva posición Y después de la tabla
     */
    private agregarTabla(
        doc: jsPDF,
        headers: string[],
        data: any[][],
        startY: number,
        headFillColor: Color,
        headTextColor: number,
        theme: 'striped' | 'grid' | 'plain' = 'striped'
    ): number {
        autoTable(doc, {
            head: [headers],
            body: data,
            startY: startY,
            styles: {
                fontSize: 10,
                cellPadding: 3,
            },
            headStyles: {
                fillColor: headFillColor,
                textColor: headTextColor,
                halign: 'center',
            },
            bodyStyles: {
                halign: 'center',
            },
            margin: { left: 15, right: 15 },
            theme: theme,
        });

        return (doc as any).lastAutoTable.finalY + 10;
    }

    public getPrintConfig(): any {
        return {
            canvasScale: 2,           // Adjust the scale as needed
            orientation: 'p' as 'p' | 'l', // 'p' for portrait, 'l' for landscape
            width: 210,               // Width in mm (A4 size)
            height: 297               // Height in mm (A4 size)
        };
    }

    back(): void {
        this.router.navigate(['dashboard', 'mantenimiento']);
    }


    createCsv(resp: { csv: string[] }, multiple: boolean = false): void {
        //console.log('resp', resp);

        if (resp.csv != null) {
            let csvContent = 'data:text/csv;charset=' + this.charset + ',\ufeff';
            const rows = resp.csv;

            rows.forEach((rowArray) => {
                const row = rowArray;

                csvContent += row;
            });
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement('a');

            link.setAttribute('href', encodedUri);
            if (multiple === false) {
                link.setAttribute('download', 'Ropo_' + this.dni + '.csv');
            } else {
                link.setAttribute('download', 'Ropo_multiple.csv');
            }

            document.body.appendChild(link); // Required for FF

            link.click(); // This will download the data file named "my_data.csv".
        }
    }

    public extraerCarnetsDeROPO(): any[] {
        const carnets: any[] = [];
        for (const fila of this.informeROPO) {
            const nivel = fila.nivel?.trim() ?? '';
            const categoria = (fila['categoría'] ?? '').toLowerCase();
            const caducidad = fila.caducidad ?? '';
            if ((!nivel || nivel === '-' || nivel === '') &&
                categoria.includes('asesoramiento')) {
                carnets.push({
                    tipo_carnet: tipoCarnet.ASESOR,
                    caducidad: caducidad,
                    codigo: fila['código'],
                    nombre: fila.nombre
                });
                continue;
            }
            if (nivel.includes('Nivel')) {
                const partes = nivel.split(',');
                for (const parte of partes) {
                    const match = parte.match(/Nivel\s+([\p{L}ÁÉÍÓÚÜáéíóúüÑñ]+)\s*\((.*?)\)/iu);
                    if (match) {
                        const tipo = match?.[1]?.toUpperCase() ?? '';
                        const cad = match[2];
                        carnets.push({
                            tipo_carnet: tipo,
                            caducidad: cad,
                            codigo: fila['código'],
                            nombre: fila.nombre
                        });
                    }
                }
            }
        }
        return carnets;
    }
}